export const MapLayersIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="currentcolor" />
    <g filter="url(#filter0_d_3143_6291)">
      <path
        d="M17.9929 17.7795L7.79999 22.876L17.9929 27.9724L28.1859 22.876L17.9929 17.7795Z"
        fill="#6D859C"
      />
      <path
        d="M17.9929 17.7806L7.79999 22.8771L17.9929 27.9735L28.1859 22.8771L17.9929 17.7806Z"
        stroke="#F8F9FA"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9929 12.7677L7.79999 17.8641L17.9929 22.9606L28.1859 17.8641L17.9929 12.7677Z"
        fill="#6D859C"
      />
      <path
        d="M17.9929 12.7688L7.79999 17.8652L17.9929 22.9617L28.1859 17.8652L17.9929 12.7688Z"
        stroke="#F8F9FA"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9929 7.75586L7.79999 12.8523L17.9929 17.9488L28.1859 12.8523L17.9929 7.75586Z"
        fill="#6D859C"
      />
      <path
        d="M17.9929 7.75697L7.79999 12.8534L17.9929 17.9499L28.1859 12.8534L17.9929 7.75697Z"
        stroke="#F8F9FA"
        strokeWidth="1.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3143_6291"
        x="3.95624"
        y="4.91322"
        width="28.0734"
        height="27.9041"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3143_6291" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3143_6291"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
